import { useInfiniteQuery } from '@tanstack/react-query';

import { client } from '../common';
import type { Car } from './types';

type Variables = {
  address: string;
  boundingBox: {
    topRight: {
      lat: number;
      lng: number;
    };
    bottomLeft: {
      lat: number;
      lng: number;
    };
  };
  startDatetime: string;
  endDatetime: string;
  deliveryAddress?: string;
  returnAddress?: string;
  sort: string;
  locationId?: number;
  modelIds: number[];
  minDailyPrice?: number;
  maxDailyPrice?: number;
  autopilotTypes: number[];
  numSeats: number[];
  batteryRanges: number[];
  carIds: number[];
};

type CarsAvailablePage = {
  data: Car[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

// Utility to check if required params are defined
const areRequiredParamsDefined = (
  variables: Variables,
  requiredKeys: (keyof Variables)[]
) => requiredKeys.every((key) => variables[key] !== '');

const fetchReservations = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    // console.log('Making API call, pageParam:', pageParam);

    let params: Record<string, any> = {
      page: pageParam,
      per_page: 5,
      state: variables.state,
    };

    const response = await client.get('v2/reservations', { params });

    return response.data;
  } catch (error) {
    console.error('fetchReservations error:', error);
    throw error;
  }
};

export const useReservations = (variables: Variables) => {
  const requiredKeys: (keyof Variables)[] = ['state'];

  const shouldFetch = areRequiredParamsDefined(variables, requiredKeys);

  return useInfiniteQuery({
    // queryKey: ['reservations', variables],
    queryKey: ['reservations'],
    queryFn: ({ pageParam = 1 }) =>
      fetchReservations({
        pageParam,
        variables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: CarsAvailablePage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
    enabled: shouldFetch,
  });
};
